<div class="my-8 mx-auto">
  <!-- Header -->
  <div class="mb-4 flex flex-row justify-between items-center w-full">
    <app-btn-back routeTo=".." icon="fa fa-chevron-left"></app-btn-back>
    @if (!group?.titheCollectionEnabled && (isTreasurer || isAdmin)) {
    <button (click)="enableTithe()"
      class="bg-primary-500 hover:bg-primary-600 text-white font-semibold py-2 px-4 rounded-lg text-sm transition-all focus:outline-none shadow-sm flex items-center gap-1.5">
      <i class="fa fa-plug"></i> Enable Tithe
    </button>
    }
  </div>

  <div class="flex flex-row justify-between items-center mb-4">
    <h1 class="text-2xl font-semibold text-primary-500 tracking-tight">Accounting Ledger</h1>
    <span class="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-lg text-xs font-semibold"
      [ngClass]="isTreasurer ? 'bg-indigo-100 text-indigo-600' : (isAdmin ? 'bg-amber-100 text-amber-800' : 'bg-red-100 text-red-800')">
      <i class="fa" [ngClass]="isTreasurer ? 'fa-pen' : 'fa-eye'"></i>
      {{ isTreasurer ? 'Treasurer (Read & Write)' : (isAdmin ? 'Admin (Read Only)' : 'Restricted') }}
    </span>
  </div>

  @if (showCreateReport) {
  <app-create-expense-report [groupId]="groupId" [report]="editingReport" [isTreasurer]="isTreasurer"
    [groupCurrency]="group?.currency || 'USD'" (onClose)="showCreateReport = false; editingReport = null"
    (onSave)="handleReportSave()">
  </app-create-expense-report>
  } @else {
  <!-- Navigation Tabs -->
  <div class="flex border-b border-blueGray-200 mb-6 gap-2">
    <button (click)="activeTab = 'summary'"
      [ngClass]="activeTab === 'summary' ? 'border-secondary-500 text-secondary-600 font-bold border-b-2' : 'text-blueGray-500 hover:text-blueGray-700 font-medium'"
      class="px-4 py-2.5 text-sm transition-all focus:outline-none">
      <i class="fa fa-chart-pie mr-1.5"></i> Summary
    </button>
    <button (click)="activeTab = 'ledger'"
      [ngClass]="activeTab === 'ledger' ? 'border-secondary-500 text-secondary-600 font-bold border-b-2' : 'text-blueGray-500 hover:text-blueGray-700 font-medium'"
      class="px-4 py-2.5 text-sm transition-all focus:outline-none">
      <i class="fa fa-list mr-1.5"></i> Ledger
    </button>
    <button (click)="activeTab = 'funding'"
      [ngClass]="activeTab === 'funding' ? 'border-secondary-500 text-secondary-600 font-bold border-b-2' : 'text-blueGray-500 hover:text-blueGray-700 font-medium'"
      class="px-4 py-2.5 text-sm transition-all focus:outline-none">
      <i class="fa fa-hand-holding-heart mr-1.5"></i> Funding Requests
    </button>
    <button (click)="activeTab = 'reports'; showCreateReport = false; editingReport = null"
      [ngClass]="activeTab === 'reports' ? 'border-secondary-500 text-secondary-600 font-bold border-b-2' : 'text-blueGray-500 hover:text-blueGray-700 font-medium'"
      class="px-4 py-2.5 text-sm transition-all focus:outline-none">
      <i class="fa fa-file-invoice mr-1.5"></i> Expense Reports
    </button>
  </div>

  <!-- Tab Contents -->
  <div [ngSwitch]="activeTab">

    <!-- Tab 1: Ledger View -->
    <div *ngSwitchCase="'ledger'" class="w-full flex flex-col gap-6">

      @if (isTreasurer) {
      <div class="flex flex-row justify-between items-center mb-1">
        <span class="text-md font-semibold text-primary-400">Transactions</span>
        <div class="flex flex-row gap-4 items-center">
          <button (click)="openCreateExpenseReport()"
            class="flex items-center gap-1.5 bg-transparent px-2 py-1 text-primary-300 hover:text-primary-500 text-sm transition-colors focus:outline-none">
            <i class="fa fa-plus"></i> Add Expense
          </button>
          <button (click)="ledgerForm.patchValue({ type: 'income' }); showLedgerModal = true"
            class="flex items-center gap-1.5 bg-transparent px-2 py-1 text-primary-300 hover:text-primary-500 text-sm transition-colors focus:outline-none">
            <i class="fa fa-plus"></i> Add Income
          </button>
        </div>
      </div>
      }

      <!-- Search and Filters bar -->
      <div
        class="bg-white p-4 rounded-xl border border-blueGray-100 shadow-sm flex flex-col lg:flex-row gap-3 items-center w-full">
        <div class="flex-1 relative w-full flex items-center">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 text-blueGray-400 flex items-center"><i class="fa fa-search text-xs"></i></span>
          <input type="text" placeholder="Search by description, payer or tags..." [value]="tempSearchQuery"
            (input)="tempSearchQuery = $any($event.target).value" (keydown.enter)="executeSearch()"
            class="w-full pl-10 pr-10 py-2 border border-blueGray-200 rounded-lg text-sm bg-blueGray-50 focus:border-primary-500 focus:outline-none" />
          @if (tempSearchQuery) {
          <button (click)="clearSearch()"
            class="absolute right-3 top-1/2 -translate-y-1/2 text-blueGray-400 hover:text-blueGray-600 focus:outline-none flex items-center">
            <i class="fa fa-times text-xs"></i>
          </button>
          }
        </div>
        <div class="flex gap-2 w-full lg:w-auto items-center">
          <select [value]="tempMonth" (change)="tempMonth = $any($event.target).value"
            class="flex-1 lg:flex-initial border border-blueGray-200 rounded-lg text-sm bg-blueGray-50 p-2 focus:border-primary-500 focus:outline-none">
            @for (m of months; track m.value) {
            <option [value]="m.value">{{ m.label }}</option>
            }
          </select>
          <input type="number" placeholder="Year" [value]="tempYear" (input)="tempYear = $any($event.target).value"
            (keydown.enter)="executeSearch()"
            class="w-24 border border-blueGray-200 rounded-lg text-sm bg-blueGray-50 p-2 text-center focus:border-primary-500 focus:outline-none" />
          <button (click)="executeSearch()"
            class="bg-primary-500 hover:bg-primary-600 text-white font-semibold py-2.5 px-4 rounded-lg text-sm transition-all focus:outline-none shadow-sm flex items-center gap-1.5 shrink-0">
            <i class="fa fa-search"></i> Search
          </button>
          @if (isSearching) {
          <button (click)="clearSearch()"
            class="bg-blueGray-100 hover:bg-blueGray-200 text-blueGray-700 font-semibold py-2.5 px-4 rounded-lg text-sm transition-all focus:outline-none shrink-0 border border-blueGray-200">
            Clear
          </button>
          }
        </div>
      </div>

      <!-- Ledger Cards Container -->
      <div class="w-full min-h-[400px] flex flex-col gap-3">
        @if (filteredEntries.length === 0) {
        <div
          class="bg-white rounded-xl border border-blueGray-100 shadow-sm p-6 flex flex-col items-center justify-center py-20 text-blueGray-400">
          <i class="fa fa-file-invoice-dollar text-4xl mb-3"></i>
          <p class="text-sm">No ledger entries found matching filters.</p>
        </div>
        } @else {
        <div class="flex flex-col gap-3">
          @for (entry of filteredEntries; track entry.id) {
          <div
            class="bg-white p-4 rounded-xl border border-blueGray-100 shadow-sm hover:shadow-md transition-all flex flex-row justify-between items-start w-full gap-4">
            <!-- Left side: details in a flex-col -->
            <div class="flex flex-col gap-2 flex-1 min-w-0">
              <!-- Date, Type, Category -->
              <div class="flex flex-wrap items-center gap-2">
                <span class="text-xs text-blueGray-400 font-semibold uppercase tracking-wider">
                  {{ getEntryDate(entry) | date: 'mediumDate' }}
                </span>
                <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-semibold capitalize"
                  [ngClass]="(entry.type === 'income' || entry.type === 'payment') ? 'bg-emerald-50 text-emerald-800' : 'bg-red-50 text-red-800'">
                  @if (entry.type === 'expense') {
                  <span>{{ entry.type }}</span>
                  <i class="fa fa-arrow-up text-[10px]"></i>
                  } @else if (entry.type === 'payment') {
                  <span>{{ entry.type }}</span>
                  <i class="fa fa-arrow-down text-[10px]"></i>
                  } @else {
                  <i class="fa fa-arrow-down text-[10px]"></i>
                  <span>{{ entry.type }}</span>
                  }
                </span>
                @if ((entry.type === 'income' || entry.type === 'payment') && entry.category) {
                <span
                  class="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold capitalize bg-blueGray-100 text-blueGray-800">
                  {{ entry.category }}
                </span>
                }
              </div>

              <!-- Description -->
              <div class="text-base font-bold text-blueGray-800 leading-snug break-words">
                {{ entry.description }}
              </div>

              <!-- Payer/Source -->
              @if (entry.payerName) {
              <div class="text-xs text-blueGray-500 flex items-center gap-1.5 mt-0.5">
                <i class="fa fa-user text-blueGray-400"></i>
                <span class="font-medium text-blueGray-600">{{ entry.payerName }}</span>
              </div>
              }

              <!-- Tags / Stripe badge -->
              <div class="flex flex-wrap gap-1 mt-1">
                @if (entry.stripeSessionId) {
                <span
                  class="inline-block text-[10px] text-blue-500 font-semibold uppercase tracking-wider bg-blue-50 px-1.5 py-0.5 rounded">
                  Stripe
                </span>
                }
                @if (entry.tags && entry.tags.length > 0) {
                @for (tag of entry.tags; track tag) {
                <span
                  class="inline-block text-[10px] text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full font-medium">
                  {{ tag }}
                </span>
                }
                }
              </div>
            </div>

            <!-- Right side: amount and converted amount in a flex-col -->
            <div class="flex flex-col items-end justify-start text-right shrink-0">
              <div class="text-lg font-extrabold flex items-baseline justify-end"
                [ngClass]="(entry.type === 'income' || entry.type === 'payment') ? 'text-emerald-600' : 'text-red-600'">
                <span>{{ (entry.type === 'income' || entry.type === 'payment') ? '+' : '-' }}</span>
                <span class="text-xs font-normal text-blueGray-400 uppercase ml-1 mr-1.5">{{ (entry.currency || 'USD') |
                  uppercase }}</span>
                <span>{{ entry.amount | number: '1.2-2' }}</span>
              </div>
              @if (entry.currency && entry.currency.toLowerCase() !== (group?.currency || 'USD').toLowerCase()) {
              <div class="text-xs text-blueGray-400 font-medium mt-1 flex items-baseline justify-end">
                <span>({{ (entry.type === 'income' || entry.type === 'payment') ? '+' : '-' }}</span>
                <span class="text-[10px] font-normal uppercase ml-1 mr-1.5">{{ (group?.currency || 'USD') | uppercase
                  }}</span>
                <span>{{ (entry.amount * (entry.conversionRate || 1)) | number: '1.2-2' }})</span>
              </div>
              }
            </div>
          </div>
          }
        </div>
        }
      </div>

    </div>

    <!-- Record Ledger Entry Modal Form -->
    @if (showLedgerModal) {
    <div class="fixed inset-0 bg-blueGray-900 bg-opacity-50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div
        class="bg-white rounded-2xl max-w-md w-full shadow-2xl p-6 border border-blueGray-100 relative animate-in fade-in zoom-in duration-200 max-h-[90vh] overflow-y-auto">
        <button (click)="showLedgerModal = false"
          class="absolute right-4 top-4 text-blueGray-400 hover:text-blueGray-600 focus:outline-none">
          <i class="fa fa-times text-lg"></i>
        </button>

        <h3 class="text-xl font-bold text-blueGray-800 mb-4">Record Income</h3>

        <form [formGroup]="ledgerForm" (ngSubmit)="saveLedger()" class="flex flex-col gap-4">

          <!-- Currency & Amount -->
          <div class="flex gap-2">
            <div class="w-1/3">
              <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Currency *</label>
              <select formControlName="currency"
                class="w-full rounded-lg border border-blueGray-200 bg-blueGray-50 p-2.5 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none">
                <option value="usd">USD</option>
                <option value="eur">EUR</option>
                <option value="gbp">GBP</option>
              </select>
            </div>
            <div class="w-2/3">
              <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Amount *</label>
              <input type="number" formControlName="amount" placeholder="0.00"
                class="w-full py-2.5 px-3 rounded-lg border border-blueGray-200 bg-blueGray-50 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none" />
            </div>
          </div>

          <!-- Conversion Rate -->
          @if (ledgerForm.get('currency')?.value !== (group?.currency || 'USD').toLowerCase()) {
          <div class="animate-in fade-in slide-in-from-top-1 duration-200">
            <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Conversion Rate *</label>
            <div class="flex gap-2 items-center">
              <span class="text-sm text-blueGray-500">1 {{ ledgerForm.get('currency')?.value | uppercase }} =</span>
              <input type="number" step="0.00001" formControlName="conversionRate" placeholder="1.0"
                class="w-full py-2.5 px-3 rounded-lg border border-blueGray-200 bg-blueGray-50 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none" />
              <span class="text-sm text-blueGray-500">{{ (group?.currency || 'USD') | uppercase }}</span>
            </div>
            <p class="text-xs text-blueGray-400 mt-1 font-normal normal-case leading-relaxed">
              Specify the conversion rate to calculate the equivalent amount in the group's default currency.
            </p>
          </div>
          }

          <!-- Date -->
          <div>
            <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Date *</label>
            <input type="date" formControlName="date"
              class="w-full py-2.5 px-3 rounded-lg border border-blueGray-200 bg-blueGray-50 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none" />
          </div>

          <!-- Payer Name -->
          <div>
            <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Payer / Source Name</label>
            <input type="text" formControlName="payerName" placeholder="e.g. Member Name, Cash donation"
              class="w-full py-2.5 px-3 rounded-lg border border-blueGray-200 bg-blueGray-50 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none" />
          </div>

          <!-- Category (Only for Income) -->
          @if (ledgerForm.value.type === 'income') {
          <div>
            <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Category *</label>
            <select formControlName="category"
              class="w-full rounded-lg border border-blueGray-200 bg-blueGray-50 p-2.5 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none">
              <option value="tithe">Tithe</option>
              <option value="dividends">Dividends</option>
              <option value="interest">Interest</option>
              <option value="donations">Donations</option>
              <option value="other">Other</option>
            </select>
          </div>
          }

          <!-- Description -->
          <div>
            <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Description *</label>
            <input type="text" formControlName="description" placeholder="What is this transaction for?"
              class="w-full py-2.5 px-3 rounded-lg border border-blueGray-200 bg-blueGray-50 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none" />
          </div>

          <!-- Tags -->
          <div>
            <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Tags (comma-separated)</label>
            <input type="text" formControlName="tags" placeholder="e.g. facility, supplies, donation"
              class="w-full py-2.5 px-3 rounded-lg border border-blueGray-200 bg-blueGray-50 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none" />
          </div>

          <!-- Submit buttons -->
          <div class="flex gap-3 justify-end mt-4">
            <button type="button" (click)="showLedgerModal = false"
              class="bg-blueGray-100 hover:bg-blueGray-200 text-blueGray-700 font-bold py-2.5 px-4 rounded-xl text-sm transition-all focus:outline-none">
              Cancel
            </button>
            <button type="submit" [disabled]="ledgerForm.invalid || isSubmittingLedger"
              class="flex items-center gap-2 bg-primary-500 hover:bg-primary-600 disabled:bg-primary-300 text-white font-bold py-2.5 px-5 rounded-xl shadow-lg transition-all focus:outline-none">
              @if (isSubmittingLedger) {
              <i class="fa fa-spinner fa-spin"></i> Saving...
              } @else {
              <i class="fa fa-save"></i> Save Transaction
              }
            </button>
          </div>
        </form>
      </div>
    </div>
    }

    <!-- Tab 2: Group Summary Cards -->
    <div *ngSwitchCase="'summary'" class="flex flex-col gap-6">

      <!-- Metrics Grid -->
      <div class="flex flex-col md:flex-row gap-4 w-full">
        <!-- Total Income -->
        <div class="flex flex-col flex-1 bg-white rounded-xl p-4 shadow-sm border border-gray-200 justify-between">
          <div class="flex flex-row justify-between items-center">
            <span class="text-sm tracking-wider text-primary-300">Total Income</span>
            <i class="fa-solid fa-arrow-down text-xl text-emerald-600"></i>
          </div>
          <h2 class="mt-2 text-3xl font-black text-emerald-600 flex items-baseline">
            <span class="text-sm font-normal text-blueGray-400 uppercase mr-1.5">{{ (group?.currency || 'USD') |
              uppercase }}</span>
            <span>{{ totalGroupIncome | number: '1.2-2' }}</span>
          </h2>
        </div>

        <!-- Total Expenses -->
        <div class="flex flex-col flex-1 bg-white rounded-xl p-4 shadow-sm border border-gray-200 justify-between">
          <div class="flex flex-row justify-between items-center">
            <span class="text-sm tracking-wider text-primary-300">Total Expenses</span>
            <i class="fa-solid fa-arrow-up text-lg text-red-600"></i>
          </div>
          <h2 class="mt-2 text-3xl font-black text-red-600 flex items-baseline justify-start">
            <span class="text-sm font-normal text-blueGray-400 uppercase mr-1.5">{{ (group?.currency || 'USD') |
              uppercase }}</span>
            <span>{{ totalGroupExpenses | number: '1.2-2' }}</span>
          </h2>
        </div>

        <!-- Net Balance -->
        <div class="flex flex-col flex-1 bg-white rounded-xl p-4 shadow-sm border border-gray-200 justify-between"
          [ngClass]="netGroupBalance >= 0 ? 'bg-gradient-to-tr from-emerald-500 to-teal-600 text-white' : 'bg-gradient-to-tr from-rose-500 to-red-600 text-white'">
          <div class="flex flex-row justify-between items-center">
            <span class="text-sm tracking-wider opacity-85">Net Balance</span>
            <i class="fa-solid fa-wallet text-xl"></i>
          </div>
          <h2 class="mt-2 text-3xl font-black flex items-baseline">
            <span class="text-sm font-normal opacity-75 uppercase mr-1.5">{{ (group?.currency || 'USD') | uppercase
              }}</span>
            <span>{{ netGroupBalance | number: '1.2-2' }}</span>
          </h2>
        </div>
      </div>

      <!-- Chart / Visual Breakdowns placeholder since we don't have charts packages, let's make a beautiful HTML breakdown -->
      <div class="bg-white rounded-xl p-4 shadow-sm border border-gray-200">
        <div class="flex justify-between items-center mb-4 pb-4 border-b border-gray-200">
          <div>
            <h3 class="text-lg font-bold text-gray-800">Financial Overview</h3>
            @if (getLastUpdatedDate()) {
            <p class="text-xs text-gray-400 mt-1 flex items-center gap-1.5">
              <i class="fa fa-clock"></i>
              Last synced: {{ getLastUpdatedDate() | date: 'medium' }}
            </p>
            }
          </div>
          <button (click)="recalculateSummary()"
            class="flex items-center gap-2 px-4 py-2 text-sm font-semibold text-primary-600 hover:text-primary-800 bg-primary-50 hover:bg-primary-100 active:bg-primary-200 rounded-xl transition-all duration-200"
            [disabled]="isRecalculating">
            <i class="fa fa-sync" [ngClass]="{'fa-spin': isRecalculating}"></i>
            {{ isRecalculating ? 'Syncing...' : 'Sync Data' }}
          </button>
        </div>
        <p class="text-sm text-gray-500 mb-6">
          This summary displays group-wide transactions compiled from both online member contributions
          (donations/funding) and manual ledger entries.
        </p>

        <div class="flex flex-col gap-3">
          <div class="flex justify-between items-center text-sm font-semibold">
            <span class="text-gray-600">Total Inflow</span>
            <span class="text-emerald-600 flex items-baseline">
              <span class="text-xs font-normal text-blueGray-400 uppercase mr-1">{{ (group?.currency || 'USD') |
                uppercase }}</span>
              <span>{{ totalGroupIncome | number: '1.2-2' }}</span>
            </span>
          </div>
          <div class="w-full bg-gray-100 rounded-full h-3">
            <div class="bg-emerald-500 h-3 rounded-full"
              [style.width.%]="netGroupBalance >= 0 ? 100 : (totalGroupIncome / (totalGroupIncome + totalGroupExpenses) * 100)">
            </div>
          </div>

          <div class="flex justify-between items-center text-sm font-semibold mt-4">
            <span class="text-gray-600">Total Outflow (Expenses)</span>
            <span class="text-red-600 flex items-baseline">
              <span class="text-xs font-normal text-blueGray-400 uppercase mr-1">{{ (group?.currency || 'USD') |
                uppercase }}</span>
              <span>{{ totalGroupExpenses | number: '1.2-2' }}</span>
            </span>
          </div>
          <div class="w-full bg-gray-100 rounded-full h-3">
            <div class="bg-red-500 h-3 rounded-full"
              [style.width.%]="netGroupBalance < 0 ? 100 : (totalGroupExpenses / (totalGroupIncome || 1) * 100)"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab 3: Funding View -->
    <div *ngSwitchCase="'funding'" class="w-full flex flex-col gap-6">
      <div class="bg-white rounded-2xl p-6 shadow-sm border border-gray-200 min-h-[400px]">
        <app-funding [groupId]="groupId" [isEmbedded]="true"></app-funding>
      </div>
    </div>

    <!-- Tab 4: Expense Reports View -->
    <div *ngSwitchCase="'reports'" class="w-full flex flex-col gap-6">

      <!-- Header row inside the tab -->
      <div class="flex flex-row justify-between items-center">
        <h3 class="text-lg font-bold text-blueGray-800">Expense Reports</h3>
        @if (isTreasurer) {
        <app-btn-action (click)="openCreateExpenseReport()" icon="fa fa-plus" bgColor="bg-transparent hover:bg-gray-200"
          [shadow]="false" textColor="text-primary-300 active:text-primary-500 hover:text-primary-500"
          label="Add Expense Report"></app-btn-action>
        }
      </div>

      <!-- Reports List Card -->
      @if (expenseReports.length === 0) {
      <div
        class="bg-white rounded-xl border border-blueGray-100 shadow-sm p-6 overflow-x-auto min-h-[400px] w-full flex flex-col items-center justify-center py-20 text-blueGray-400">
        <i class="fa fa-file-invoice text-4xl mb-3"></i>
        <p class="text-sm">No expense reports found.</p>
      </div>
      } @else {
      <div class="flex flex-col gap-4">
        @for (report of expenseReports; track report.id) {
        <div class="border border-blueGray-100 rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow bg-white">
          <!-- Row 1: Title & Status on left, Actions on right -->
          <div class="flex flex-row justify-between items-center gap-3 mb-3">
            <div class="flex items-center gap-2">
              <h4 class="font-bold text-blueGray-800 text-base">{{ report.title }}</h4>
              <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold uppercase tracking-wider"
                [ngClass]="report.status === 'draft' ? 'bg-amber-100 text-amber-800' : 'bg-emerald-100 text-emerald-800'">
                {{ report.status }}
              </span>
            </div>

            <div class="flex gap-2 items-center">
              @if (report.status === 'draft') {
              <!-- Edit Button (Only creator or treasurer) -->
              @if (isTreasurer || report.createdById === userId) {
              <button (click)="openCreateExpenseReport(report)"
                class="text-primary-500 hover:text-primary-600 bg-white border border-primary-200 hover:border-primary-400 px-3 py-1.5 rounded-lg text-xs font-semibold flex items-center gap-1 transition-colors">
                <i class="fa fa-edit"></i> Edit
              </button>
              }

              <!-- Publish Button (Only Treasurers) -->
              @if (isTreasurer) {
              <button (click)="publishReport(report)"
                class="text-white bg-emerald-600 hover:bg-emerald-700 px-3 py-1.5 rounded-lg text-xs font-semibold flex items-center gap-1 transition-colors shadow-sm">
                <i class="fa fa-upload"></i> Publish
              </button>
              }
              }

              <!-- Toggle Expenses Details (Chevron button at the end) -->
              <button (click)="report.showExpenses = !report.showExpenses"
                class="text-blueGray-500 hover:text-primary-500 bg-white border border-blueGray-200 px-3 py-1.5 rounded-lg flex items-center justify-center transition-colors">
                <i class="fa" [ngClass]="report.showExpenses ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              </button>
            </div>
          </div>

          <!-- Row 2: Created by on left, Total Amount on right -->
          <div class="flex flex-row justify-between items-center gap-3">
            <div>
              <p class="text-xs text-blueGray-500">
                Created by <span class="font-semibold text-blueGray-700">{{ report.createdBy }}</span> on {{
                getReportDate(report) | date: 'mediumDate' }} • {{ report.expenses?.length || 0 }} expense(s)
              </p>
            </div>

            <div class="text-right">
              <span class="text-xs uppercase font-semibold text-blueGray-400 block">Total Amount</span>
              <span class="text-lg font-extrabold text-primary-500 flex items-baseline justify-end">
                <span class="text-xs font-normal text-blueGray-400 uppercase mr-1">{{ (report.currency || 'USD') |
                  uppercase }}</span>
                <span>{{ report.totalAmount | number: '1.2-2' }}</span>
              </span>
            </div>
          </div>

          <!-- Expanded Expenses List -->
          @if (report.showExpenses && report.expenses && report.expenses.length > 0) {
          <div class="mt-4 pt-4 border-t border-blueGray-100 overflow-x-auto">
            <table class="w-full text-left border-collapse text-xs">
              <thead>
                <tr class="border-b border-blueGray-100 text-blueGray-400 font-semibold uppercase">
                  <th class="py-2 px-1">Date</th>
                  <th class="py-2 px-1">Description</th>
                  <th class="py-2 px-1">Vendor/Merchant</th>
                  <th class="py-2 px-1">Category/Tags</th>
                  <th class="py-2 px-1 text-right">Amount</th>
                  <th class="py-2 px-1 text-center">Receipt</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-blueGray-50 text-blueGray-600">
                @for (exp of report.expenses; track $index) {
                <tr class="hover:bg-blueGray-50/50">
                  <td class="py-2 px-1 whitespace-nowrap">{{ exp.date | date: 'shortDate' }}</td>
                  <td class="py-2 px-1 font-medium text-blueGray-800">{{ exp.description }}</td>
                  <td class="py-2 px-1">
                    @if (exp.from || exp.to) {
                    <span>{{ exp.from || 'N/A' }} ➔ {{ exp.to || 'N/A' }}</span>
                    } @else {
                    <span>-</span>
                    }
                  </td>
                  <td class="py-2 px-1">
                    @if (exp.tags) {
                    <span class="inline-block bg-blueGray-100 text-blueGray-600 px-1.5 py-0.5 rounded text-[10px]">{{
                      exp.tags }}</span>
                    } @else {
                    <span>-</span>
                    }
                  </td>
                  <td class="py-2 px-1 text-right font-semibold text-blueGray-800">
                    <div class="flex items-baseline justify-end">
                      <span class="text-[10px] font-normal text-blueGray-400 uppercase mr-1">{{ (exp.currency ||
                        report.currency || 'USD') | uppercase }}</span>
                      <span>{{ exp.amount | number: '1.2-2' }}</span>
                    </div>
                    @if (exp.currency && exp.currency.toLowerCase() !== (group?.currency || 'USD').toLowerCase()) {
                    <div class="text-[10px] text-blueGray-400 font-normal flex items-baseline justify-end mt-0.5">
                      <span>(</span>
                      <span class="text-[9px] font-normal uppercase mr-0.5">{{ (group?.currency || 'USD') | uppercase
                        }}</span>
                      <span>{{ (exp.amount * (exp.conversionRate || 1)) | number: '1.2-2' }} equivalent)</span>
                    </div>
                    }
                  </td>
                  <td class="py-2 px-1 text-center">
                    @if (exp.receiptUrl) {
                    <a [href]="exp.receiptUrl" target="_blank"
                      class="text-primary-500 hover:text-primary-600 font-medium inline-flex items-center gap-1">
                      <i class="fa fa-paperclip"></i> View
                    </a>
                    } @else {
                    <span class="text-blueGray-400">No Receipt</span>
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
          }
        </div>
        }
      </div>
      }

    </div>

  </div>
  }

  <!-- Tithe Coming Soon Modal -->
  @if (showTitheComingSoonModal) {
  <div class="fixed inset-0 bg-blueGray-900 bg-opacity-50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
    <div
      class="bg-white rounded-2xl max-w-sm w-full shadow-2xl p-6 border border-blueGray-100 relative animate-in fade-in zoom-in duration-200 text-center animate-fade-in animate-zoom-in">
      <button (click)="showTitheComingSoonModal = false"
        class="absolute right-4 top-4 text-blueGray-400 hover:text-blueGray-600 focus:outline-none">
        <i class="fa fa-times text-lg"></i>
      </button>

      <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-emerald-50 text-emerald-600 mb-4">
        <i class="fa fa-plug text-xl"></i>
      </div>

      <h3 class="text-lg font-bold text-blueGray-800 mb-2">Online Tithe Setup</h3>
      <p class="text-sm text-blueGray-500 mb-6 leading-relaxed">
        Online tithe collections is under development and will be coming soon!
      </p>
      <p class="text-sm text-blueGray-500 mb-6 leading-relaxed">
        In the meantime, please record offline payments directly using the <strong>Add Income</strong> feature.
      </p>

      <button (click)="showTitheComingSoonModal = false"
        class="w-full bg-primary-500 hover:bg-primary-600 text-white font-bold py-2.5 px-4 rounded-xl text-sm transition-all shadow-md hover:shadow-lg focus:outline-none">
        Got it
      </button>
    </div>
  </div>
  }
</div>